export default "__VITE_ASSET__S_Rc$tGV__"